<template>
  <div class="remindList">
    <!-- 订单列表 -->
    <List :page="page" @requestList="handleLoad">
      <div class="remindBox" v-for="(item, index) in orderList" :key="index">
        <div class="remind-top">
          <div class="leftName">{{name}}</div>
          <div class="rightName color1" v-if="item.status === 1">待提醒</div>
          <div class="rightName" v-if="item.status === 2">已提醒</div>
        </div>
        <div class="remind-content">
          <div class="content">
            <div>客户</div>
            <div>{{item.customerName}}</div>
          </div>
          <div class="content">
            <div>提醒时间</div>
            <div>{{item.noticeTime | dateFormat}}</div>
          </div>
          <div class="content">
            <div>提醒内容</div>
            <div>{{item.content}}</div>
          </div>
          <div class="content">
            <div>创建时间</div>
            <div>{{item.created | dateFormat}}</div>
          </div>
          <div class="content">
            <div>创建人</div>
            <div>{{item.operatorName}}</div>
          </div>
        </div>
      </div>
    </List>
    <div class="addNAme" @click="addEvemt">添加</div>
  </div>
</template>
// import { dateFormat } from '@/filters'
<script>
import List from '@/components/list'
import { customerfollowupnoticelist } from '@/api/remind'
export default {
  components: { List },
  data() {
    return {
      showDatePicker: false,
      orderList: [],
      customerId: Number(this.$route.query.customerId),
      name: this.$route.query.name || '',
      page: {
        currentPage: 1,
        currentCount: 10,
        totalCount: 0,
        totalPage: 0
      }
    }
  },
  created() {
    this.orderList = []
    this.getremindrEvemt({
      customerId: this.customerId,
      page: 1,
      count: this.page.currentCount
    })
  },
  methods: {
    addEvemt () {
      this.$router.push({name: 'remindadd', query: {customerId: this.customerId, name: this.name}})
    },
    handleLoad() {
      const params = {
        customerId: this.customerId,
        page: this.page.currentPage + 1,
        count: this.page.currentCount
      };
      this.getremindrEvemt(params);
    },
    getremindrEvemt(params) {
      customerfollowupnoticelist(params).then(res => {
        if (res.errcode === 0) {
          this.orderList = this.orderList.concat(res.data)
          this.page = res.page;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.remindList {
  height: 100%;
  padding-top: 5px;
  .remindBox{
    padding: 5px 10px;
    .remind-top{
      padding-left: 10px;
      padding-right: 10px;
      background: #ffffff;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e5e5e5;
      .leftName{
        font-size: 14px;
        color: #333;
      }
      .rightName{
        font-size: 14px;
        color: #333;
      }
      .color1{
        color: #5bad2f;
      }
    }
    .remind-content{
      padding: 10px;
      background: #ffffff;
      .content{
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #aaa;
      }
    }
  }
  .addNAme{
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #5bad2f;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-radius: 100px;
    top: 80%;
    right: 5%;
  }
}
</style>